'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import makeLoadable from 'AdsUI/lib/makeLoadable';
const AudienceCreationTypePanelLoader = makeLoadable(() => import('AdsUI/components/audiences/AudienceCreationTypePanelSection'));

const AudienceCreationTypeSelectPanel = ({
  audienceCounts,
  loading,
  onAudienceTypeSelected,
  fbAccountConnected,
  liAccountConnected,
  hasAccessToContactListAudiences,
  closeAudiencePanel,
  isPortalUntrustworthy,
  hasAccessToCompanyListAudiences,
  listBasedAudienceLimit,
  panelKey,
  width
}) => {
  return /*#__PURE__*/_jsxs(UIPanel, {
    width: width,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: closeAudiencePanel
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "audiences.wizard.title"
        })
      })
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      children: loading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        grow: true,
        layout: "centered"
      }) : /*#__PURE__*/_jsx(AudienceCreationTypePanelLoader, {
        onAudienceTypeSelected: onAudienceTypeSelected,
        audienceCounts: audienceCounts,
        fbAccountConnected: fbAccountConnected,
        liAccountConnected: liAccountConnected,
        hasAccessToContactListAudiences: hasAccessToContactListAudiences,
        panelKey: panelKey,
        isPortalUntrustworthy: isPortalUntrustworthy,
        hasAccessToCompanyListAudiences: hasAccessToCompanyListAudiences,
        listBasedAudienceLimit: listBasedAudienceLimit
      })
    })]
  });
};

export default AudienceCreationTypeSelectPanel;